import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterNDUPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='ndu_general'
        title='NDU'
        activeTab='ndu'
        navConfig={null}
      />
    )
  }
}

export default MasterNDUPageSF
